// strings/errors.ts (M0-T06, §7.1) — one per ApiErrorCode (keys are the codes; coverage: shared:protocol/codeStrings.test.ts)
import type { StringBank } from '../schema/strings';

export default {
  unauthorized: 'Please sign in again.', forbidden: "You can't do that here.", not_found: "We couldn't find that.",
  invalid: 'Something in that request looks wrong.', name_filtered: "That name isn't allowed. Try another.",
  profile_required: 'Make your character first.', plot_invalid: 'Pick a plot first.', town_full: 'Town is full — ask the mayor to make room.',
  plot_taken: 'Someone just took that plot. Pick another.', already_resident: 'You already live in this town.',
  max_residents: 'This town already has 10 residents.', invite_expired: 'This invite has expired.', invite_revoked: 'This invite was cancelled.',
  invite_used_up: 'This invite has been used up.', too_many_towns: "You've founded as many towns as you can for now.",
  rate_limited: 'Slow down a little and try again.', not_mayor: 'Only the mayor can do that.', town_archived: 'This town is closed.',
  server_error: 'Something went wrong. Try again.',
} as const satisfies StringBank;
